/** @jsxImportSource @emotion/react */
import { MutateShopPaymentProviderTemplate } from "./MutateShopPaymentProviderTemplate";
import { useParams } from "react-router-dom";
import { useGetPaymentProvider } from "./service/shop-api";
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";

export const UpdateShopPaymentProvider = () => {
  const { paymentProviderId, shopId } = useParams();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const { data: shopPaymentProvider, isLoading } = useGetPaymentProvider({
    organizationKeyName,
    shopId: shopId!,
    id: paymentProviderId!,
  });

  return (
    <MutateShopPaymentProviderTemplate
      shopPaymentProvider={shopPaymentProvider}
      isLoading={isLoading}
    />
  );
};
